import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { of, ReplaySubject, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiTravelMemberAuthStorageService } from './travel-member-auth-storage.service';

@Injectable()
export class ApiTravelMemberAuthService {
  private readonly _travelMemberSubject: ReplaySubject<any>;
  private _loggedSubscription?: Subscription;

  constructor(
    private _apiSrv: ApiService,
    private _travelMemberAuthStorageSrv: ApiTravelMemberAuthStorageService,
    private _router: Router
  ) {
    this._travelMemberSubject = new ReplaySubject();
  }

  get travelMember(): any {
    return this._travelMemberAuthStorageSrv.travelMember;
  }

  get travelMemberId(): number {
    return this.travelMember?.id;
  }

  get travelMemberSubject() {
    return this._travelMemberSubject;
  }

  logged() {
    if (this.travelMember !== undefined) {
      return of(this.travelMember);
    }

    if (!this._loggedSubscription) {
      this._loggedSubscription = this._apiSrv
        .post('travel-member-auth/logged')
        .pipe(
          map((result) => result.data),
          tap((travelMember) => this.setTravelMember(travelMember))
        )
        .subscribe();
    }

    return this.travelMemberSubject;
  }

  login(data: { login?: string | null; password?: string | null }) {
    return this._apiSrv
      .post('travel-member-auth/login', data)
      .pipe(tap((result) => this.setTravelMember(result.data)));
  }

  logout() {
    return this._apiSrv.post('travel-member-auth/logout').pipe(
      tap(() => {
        this.setTravelMember(null);
        this._router.navigate(['/auth/login']).then();
      })
    );
  }

  register(data: { [key: string]: any }) {
    return this._apiSrv
      .post('travel-member-auth/register', data)
      .pipe(tap((result) => this.setTravelMember(result.data)));
  }

  setTravelMember(travelMember: any): void {
    this._travelMemberAuthStorageSrv.travelMember = travelMember;
    this._travelMemberSubject.next(travelMember);
  }
}
